/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import React from 'react';

const CancelPassword = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-cancelpassowrd">
    <path d="M510.976 25.6c268.288 0 485.376 218.112 485.376 485.376S779.264 997.376 510.976 997.376 25.6 779.264 25.6 510.976 243.712 25.6 510.976 25.6M510.976 0C229.376 0 0 229.376 0 510.976s229.376 510.976 510.976 510.976 510.976-229.376 510.976-510.976S793.6 0 510.976 0L510.976 0z"/>
    <path d="M282.624 510.976m-25.6 0a2.5 2.5 0 1 0 51.2 0 2.5 2.5 0 1 0-51.2 0Z"/>
    <path d="M742.4 510.976m-25.6 0a2.5 2.5 0 1 0 51.2 0 2.5 2.5 0 1 0-51.2 0Z"/>
    <path d="M281.6 741.376m-25.6 0a2.5 2.5 0 1 0 51.2 0 2.5 2.5 0 1 0-51.2 0Z"/>
    <path d="M510.976 741.376m-25.6 0a2.5 2.5 0 1 0 51.2 0 2.5 2.5 0 1 0-51.2 0Z"/>
    <path d="M741.376 741.376m-25.6 0a2.5 2.5 0 1 0 51.2 0 2.5 2.5 0 1 0-51.2 0Z"/>
    <path d="M728.064 303.104c4.096 2.048 8.192 3.072 13.312 3.072 14.336 0 25.6-11.264 25.6-25.6S755.712 256 741.376 256c-12.288 0-21.504 10.24-24.576 20.48L535.552 276.48c-3.072-10.24-12.288-19.456-24.576-19.456S489.472 266.24 486.4 276.48L306.176 276.48c-3.072-10.24-12.288-20.48-24.576-20.48-14.336 0-25.6 11.264-25.6 25.6s11.264 24.576 25.6 24.576c12.288 0 21.504-9.216 24.576-19.456l181.248 0c3.072 10.24 12.288 19.456 24.576 19.456s21.504-9.216 24.576-19.456L716.8 286.72c1.024 0 2.048 5.12 3.072 7.168l-194.56 194.56c-4.096-2.048-8.192-3.072-12.288-3.072-14.336 0-25.6 11.264-25.6 25.6s11.264 25.6 25.6 25.6 25.6-11.264 25.6-25.6c0-5.12-1.024-9.216-4.096-13.312L728.064 303.104z" />
  </svg>
};

export default CancelPassword;



// WEBPACK FOOTER //
// ./src/svgs/cancelPassword.js